export const ROOM_MAX_AVAILABLE_COUNT_CHANGED = 'ROOM_MAX_AVAILABLE_ROOM_CHANGED';
